export default {
      id: "nuit-faiblement-orageuse-usage",
      viewBox: "0 0 91 91",
      url: "../dist/images/" + "sprite.svg#nuit-faiblement-orageuse-usage",
      toString: function () {
        return this.url;
      }
    }